import { Injectable } from '@angular/core';
import { type CanActivate, Router, UrlTree } from '@angular/router';
import { NotificationService } from '@odin/odin-core';
import { AccessGuardService } from './access-guard.service';
import { RoleGuardService } from './role-guard.service';

/** Gates the integrations area (every route in the integrations module). */
@Injectable({ providedIn: 'root' })
export class IntegrationsGuardService implements CanActivate {
  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private roleGuardService: RoleGuardService,
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.roleGuardService.hasPermission('settings:View')) return true;

    this.notificationService.AccessDeniedDialog('Integrations');
    return this.router.parseUrl('/dashboard');
  }
}

/**
 * Gates the Xero pages. They create and delete bindings and payment services, so they need
 * settings:Manage and the Xero feature on the selected business unit. This also covers the
 * OAuth callback, which lands on the Xero page with an authorisation code.
 */
@Injectable({ providedIn: 'root' })
export class XeroIntegrationGuardService implements CanActivate {
  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private roleGuardService: RoleGuardService,
    private accessService: AccessGuardService,
  ) {}

  canActivate(): boolean | UrlTree {
    if (
      this.accessService.buidHasFeature('xero') &&
      this.roleGuardService.hasPermission('settings:Manage')
    ) {
      return true;
    }

    this.notificationService.AccessDeniedDialog('Xero integration management');
    return this.router.parseUrl('/settings/integrations');
  }
}
